var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4854 9.40862C5.57413 9.30299 5.67022 9.16855 5.7782 9.06543C6.64387 8.13427 7.51259 7.2038 8.3846 6.27418C10.6862 6.7061 12.8272 6.19734 14.9606 5.31427C17.039 6.19267 19.2061 6.69676 21.5413 6.27418C22.5254 7.3205 23.4853 8.36446 24.4933 9.43974C24.3804 9.63896 24.2725 9.81173 24.1765 9.99423C23.9365 10.4742 23.675 10.9279 23.4565 11.4078V11.4077C23.0056 12.3207 22.9198 13.3712 23.2166 14.3454C23.4973 15.2291 23.7172 16.1313 23.8742 17.0454C23.9733 17.7537 23.9959 18.4706 23.9413 19.1837C23.9072 19.9431 23.5074 20.6391 22.8686 21.0509C22.137 21.5767 21.365 22.0438 20.5598 22.4478C18.8798 23.211 17.1398 23.8758 15.4285 24.5886H15.4283C15.1347 24.7133 14.8029 24.7133 14.5093 24.5886C12.4669 23.847 10.4293 23.0862 8.53585 22.0038C8.05589 21.7277 7.59034 21.4158 7.13429 21.099H7.13413C6.40037 20.5954 5.96293 19.7617 5.96528 18.8717C5.91389 17.9704 6.00462 17.0665 6.23414 16.1933C6.42616 15.5046 6.58688 14.8061 6.78143 14.1173V14.1174C7.00693 13.3731 6.9619 12.5732 6.65419 11.8591C6.30129 11.0599 5.90535 10.2846 5.48535 9.40867L5.4854 9.40862ZM17.7494 16.6639C18.647 15.7472 19.547 14.9407 20.4494 13.9543L16.6646 13.3711C16.3669 12.7639 16.103 12.2143 15.8317 11.667C15.5605 11.1197 15.2942 10.5966 14.9629 9.94386L13.2494 13.3736L9.46229 13.9639L12.1767 16.6639C12.0183 17.9431 11.6967 19.1287 11.5959 20.4366L14.9726 18.6847L16.1582 19.3014C16.5109 19.4839 16.8613 19.6758 17.2214 19.8462C17.5814 20.0166 17.903 20.2973 18.3831 20.3863C18.1623 19.0904 17.9654 17.8952 17.7494 16.6639H17.7494Z",
    fill: "url(#paint0_linear_5555_84483)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5555_84483",
    x1: 5.48535,
    y1: 14.9982,
    x2: 24.4933,
    y2: 14.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.02a48eb6d7b8377b73fc5e6cd9c6b5ec.svg";
export { ForwardRef as ReactComponent };